import { ITextValidator } from "../models/validator";

const FOUT_GENERIEK = "Voer een geldige link in die begint met https:// en verwijst naar een PDF of ZIP.";
const FOUT_TE_LANG = "De link is te lang (maximaal 2048 tekens).";
const FOUT_HTTP = "Gebruik https:// in plaats van http://. Een beveiligd webadres is verplicht.";
const FOUT_IP = "Gebruik geen IP-adres. Voer een link in, bijvoorbeeld: https://www.voorbeeld.nl.";
const FOUT_HOST = "URL verwijst naar een niet-toegestane host.";

const GEBLOKKEERDE_HOSTNAMES = new Set(["localhost", "open-acc.overheid.nl", "open.overheid.nl"]);
const GEBLOKKEERDE_SUFFIXEN = [
  ".localhost",
  ".local",
  ...(process.env.REACT_APP_ENVIRONMENT === "productie" ? [".s15m.nl"] : []),
  ".internal",
  ".open-acc.overheid.nl",
  ".open.overheid.nl",
];

const IPV4_REGEX = /^(?:\d{1,3}\.){3}\d{1,3}$/;

function isIpAdres(hostname: string): boolean {
  return IPV4_REGEX.test(hostname) || (hostname.startsWith("[") && hostname.endsWith("]"));
}

function isGeblokkeerdeHostname(hostname: string): boolean {
  if (GEBLOKKEERDE_HOSTNAMES.has(hostname)) return true;
  return GEBLOKKEERDE_SUFFIXEN.some((suffix) => hostname.endsWith(suffix));
}

export class ValidUrlValidator implements ITextValidator {
  validate(value?: string): string | undefined {
    if (!value) return undefined;

    if (value.length > 2048) return FOUT_TE_LANG;

    let url: URL;
    try {
      url = new URL(value);
    } catch {
      return FOUT_GENERIEK;
    }

    if (url.protocol === "http:") return FOUT_HTTP;
    if (url.protocol !== "https:") return FOUT_GENERIEK;

    const hostname = url.hostname.toLowerCase();
    if (isIpAdres(hostname)) return FOUT_IP;
    if (isGeblokkeerdeHostname(hostname)) return FOUT_HOST;

    return undefined;
  }
}
